import { EnumEndpoints, EnumEndpointsName, EnumMethod } from "@/constants/app/type";
import { callbackToursCollections } from "./callbacks/callbackToursCollections";
import { getToursCategoriesService } from "./callbacksServices/getToursCategoriesService";
import { callbackToursCategories } from "./callbacks/callbackToursCategories";
import { callbackToursSearch } from "./callbacks/callbackToursSearch";
import { callbackTourDetail } from "./callbacks/callbackTourDetail";
import { EnumAPIKey } from "@/constants/app/api";

export const tourEnpoints = {
  [EnumEndpointsName.TOURS_COLLECTIONS]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.TOURS_COLLECTIONS,
    api: EnumAPIKey.API_TOUR,
    caller: callbackToursCollections
  },
  [EnumEndpointsName.TOURS_COLLECTIONS_BY_SLUG]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.TOURS_COLLECTIONS_BY_SLUG,
    api: EnumAPIKey.API_TOUR
  },
  [EnumEndpointsName.TOUR_DETAILS]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.TOUR_DETAILS,
    api: EnumAPIKey.API_TOUR,
    caller: callbackTourDetail
  },
  [EnumEndpointsName.TOURS_SEARCH]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.TOURS_SEARCH,
    api: EnumAPIKey.API_TOUR,
    caller: callbackToursSearch
  },
  [EnumEndpointsName.TOURS_CATEGORIES]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.TOURS_CATEGORIES,
    api: EnumAPIKey.API_TOUR,
    callerService: getToursCategoriesService,
    caller: callbackToursCategories
  },
}